import { apiV2 } from '../axios';
import { setExportRequest } from '../redux/reducers/lifebooksReducer';
import { store } from '../redux';

export const listExportRequest = async () => {
	return await apiV2.get(`/export`).then((e) => {
		store.dispatch(setExportRequest(e.data));
	});
};

export const createExportRequest = async (reqBody) => {
	return await apiV2.post(`/export/request`, reqBody);
};

export const approveExportRequest = async (requestId) => {
	await apiV2.post(`/export/${requestId}/approve`).then(() => {
		listExportRequest();
	});
};

export const denyExportRequest = async (requestId) => {
	return await apiV2.post(`/export/${requestId}/deny`).then(() => {
		listExportRequest();
	});
};

export const revokeExportRequest = async (requestId) => {
	return await apiV2.post(`/export/${requestId}/revoke`);
};

export const getLifebookVideo = async (reqBody) => {
	return await apiV2.post('/lifebook/video', reqBody);
};

export const photoExportRequest = async (reqBody) => {
	return await apiV2.post(`/export/request`, reqBody);
};
